// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/awos-limitations.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/awos-limitations/awos-limitations.js';

mount([g0]);
